module.exports = __webpack_public_path__ + "img/face-zipper.9767f2bd.svg";